<template>
  <div class="radius">
    <a class="btnall btn-only-txte btn-xl btnnomal">{{ BtnNomal }}</a>
  </div>
</template>

<script>
export default {
  name: "BtnNomal",
  props: {
    BtnNomal: {
      type: String,
      default: "送信",
    },
  },
  methods: {},
};
</script>

<style scoped>
.btnall {
  background-color: #77A88D;
  color: #ffffff;
  overflow: hidden;
  border: 0;
  border-radius: 100px;
  /* font-family: "Helvetica Neue", Arial, sans-serif; */
  display: inline-block;
  margin: 5px;
  width: 250px;
  height: 45px;
  line-height: 35px;
}
.btnall:hover {
  background-color: #0D263D;
  color: #ffffff;
  opacity: 0.7;
}
/* .btnnomal {
  width: 250px;
} */
div {
  text-align: center;
  width: 260px;
  margin-left: auto;
  margin-right: auto;
}
.radius {
  overflow: hidden;
}
a.btnall.btn-only-txte.btn-xl.btnnomal {
  border-radius: 100px;
  margin: 5px;
}
.btnall.btn-only-txte:hover {
  background-color: #0D263D;
  color: #ffffff;
  font-weight: 500;
  opacity: 0.7;
}
a{
  padding-top: 5px;
  font-size: 120%;
}
</style>
